export default function coursePickup() {
  const btn = document.querySelector('.jsCoursePickupBtn');
  const target = document.querySelector('.jsCoursePickupTarget');

  if (!btn || !target) return;

  btn.addEventListener('click', () => {
    // 実際の高さを取得
    target.style.display = 'flex';
    const height = target.scrollHeight;
    target.style.height = '0';
    target.style.overflow = 'hidden';
    
    // リフローを強制
    target.offsetHeight;
    
    // アニメーション開始
    target.classList.add('is-open');
    target.style.height = `${height}px`;
    
    // ボタンを非表示にする
    btn.classList.add('is-hidden');
    btn.setAttribute('aria-expanded', 'true');
    
    // アニメーション終了後にheightをautoに
    target.addEventListener('transitionend', function handleTransitionEnd() {
      target.style.height = 'auto';
      target.style.overflow = '';
      target.removeEventListener('transitionend', handleTransitionEnd);
    });
  });
}

